import { apiClient } from "../config";

async function getAllUsers(queryParams: any) {
  const res = await apiClient.get(`/admin/users`, {
    params: queryParams,
  })
  return res.data;
}

export default getAllUsers;
